/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import MaskedInput from "react-maskedinput";
import moment from 'moment-timezone';

import "./style.css";
import { getRequest } from "utils/request";

import { i18n } from '../../translate/i18n';
import { useNotification } from "hooks/notification";
import { useModal } from "hooks/modal";
import { states } from "utils/states";
import { useLocation } from "react-router-dom";

export default function ClientForm({
  CustomerData,
  handleConfirm,
  btnGoBack,
  history,
  skuteTicket,
  insoftOpen,
  ticketData,
  match,
  skuteChannelTicket
}) {
  //const [loading, setLoading] = useState(false);
  const [customer, setCustomer] = useState({});
  const [cellphoneDb, setcellphoneDb] = useState('');
  const [editclient, setEditClient] = useState(true);
  const [listUsersTypes, setListUsersType] = useState([]);
  const { toggleHelperId   } = useModal();
  const [isManual, setIsManual] = useState(false);
  const { selectedCompany } = useNotification();
  const location = useLocation();


  useEffect(() => {
    if (skuteTicket || insoftOpen) {
      setEditClient(false);
    } else {
      setEditClient(true);
    }

    if (CustomerData !== "") {
      if (CustomerData.dateBirth) {
        CustomerData.dateBirth = moment.utc(CustomerData.dateBirth).format('YYYY-MM-DD');
      }

      CustomerData.acceptPurchaseEmail = (CustomerData.acceptPurchaseEmail === "") ? null : CustomerData.acceptPurchaseEmail
      CustomerData.acceptPurchaseReminder = (CustomerData.acceptPurchaseReminder === "") ? null : CustomerData.acceptPurchaseReminder
      CustomerData.acceptActiveCall = (CustomerData.acceptActiveCall === "") ? null : CustomerData.acceptActiveCall
      
      setCustomer(CustomerData);
      setcellphoneDb(CustomerData.cellPhone);
    }
  }, [CustomerData]);

  useEffect(() => {
    if(customer.cellPhone && customer?.cellPhone.replace(/([^\d])+/gim, "") !== cellphoneDb) {
      setcellphoneDb('');
    }
  }, [customer])

   //Buca lista User Tipos
  const loadUserType = async() => {
    const response = await getRequest(`companiescustomerstypes?CompanyId=${selectedCompany.id}`);
    if(response) {
      setListUsersType(response.data);
    }
  }

  useEffect(() => {
   loadUserType();
  }, []);
  // const handleButtonEdit = () => {
  //   setEditClient(!editclient);
  // };
  const handleEditClient = (e) => {
    e.preventDefault();
    handleConfirm({
      CompanyId: selectedCompany.id,
      id: customer.id,
      name: customer.name,
      contact: customer.contact,
      identification: customer.identification,
      document: customer.document,
      companyDocument: customer.companyDocument,
      CompanyCustomerTypeId: !isNaN(customer.CompanyCustomerTypeId)
        ? Number(customer.CompanyCustomerTypeId)
        : null,
      gender: customer.gender,
      email: customer.email,
      cellPhone: customer.cellPhone,
      secondaryEmail: customer.secondaryEmail,
      dateBirth: customer.dateBirth,
      phone1: customer.phone1,
      branch1: customer.branch1,
      phone2: customer.phone2,
      branch2: customer.branch2,
      phone3: customer.phone3,
      branch3: customer.branch3,
      zipCode: customer.zipCode,
      address: customer.address,
      number: customer.number,
      complement: customer.complement,
      district: customer.district,
      city: customer.city,
      state: customer.state,
      acceptPurchaseEmail: (customer.acceptPurchaseEmail === "") ? null : customer.acceptPurchaseEmail,
      acceptPurchaseReminder: (customer.acceptPurchaseReminder === "") ? null : customer.acceptPurchaseReminder,
      acceptActiveCall: (customer.acceptActiveCall === "") ? null : customer.acceptActiveCall,
    });
  };

  const ConfigMask = (data) => {
    let value;
    value = data.replace(/([^\d])+/gim, "");
    return value;
  };

  const ConfigMaskCEP = (data) => {
    let value;
    value = data.replace(/([^\d])+/gim, "");

    if (String(value).length === 8) {
      getRequest(`cep?cep=${value}`).then(function (response) {
        if (!response.success) {
          setCustomer((data) => {
            return {
              ...data,
              address: "",
              number: "",
              complement: "",
              district: "",
              city: "",
              state: "",
            };
          });
        } else {
          setCustomer((data) => {
            return {
              ...data,
              address: response.data.logradouro,
              complement: response.data.complemento,
              district: response.data.bairro,
              city: response.data.localidade,
              state: response.data.uf,
            };
          });
        }
      });
    }
    return value;
  };

  useEffect(() => {
    toggleHelperId(12);
  }, []);

  useEffect(() => {
    if(match) {
      // if(location.pathname === "/dashboard/newcustomer" || location.pathname === `/dashboard/newcustomer/${match.params.id}`) {
      //   setIsManual(true);
      // } else {
      //   setIsManual(false);
      // }
      setIsManual(true);
    } else {
      setIsManual(false);
    }
  }, [location]);


  return (
    <form onSubmit={handleEditClient} className="new-client-form">
      <div className="container-geral-edit-client-form">
        <div className="container-client-page-edit-chat">
          <div className="container-area-client-details">
            <div className="area-linha-perfil-client-img">
              {customer.photo ? (
                <img
                  src={customer.photo}
                  alt="avatar"
                  className="img-area-client-chat"
                />
              ) : (
                <></>
              )}
              <div className="container-area-client-details">
                <div className="area-linha-perfil-client">
                  <div className="label-client-details-chat">
                    <strong className="text-strong-label-client-edit">
                      *{i18n.t('name')}:
                    </strong>
                    <input
                      className={
                        editclient ? "input-client-details-edit" : "disable-input"
                      }
                      disabled={!editclient || skuteChannelTicket}
                      required
                      maxLength={100}
                      value={customer.name || ""}
                      onChange={(value) =>
                        setCustomer((data) => {
                          return {
                            ...data,
                            name: value.target.value,
                          };
                        })
                      }
                    />
                  </div>
                  <div className="area-linha-perfil-client">
                    <div className="label-client-details-chat">
                      <strong className="text-strong-label-client-edit">
                      {isManual && "*"}{i18n.t('document')}:
                      </strong>
                      <MaskedInput
                        mask="111.111.111-11"
                        maxLength="14"
                        minLength="14"
                        required={isManual}
                        className={
                          editclient ? "input-client-details-edit" : "disable-input"
                        }
                        disabled={!editclient || skuteChannelTicket}
                        value={customer.document || ""}
                        onChange={(value) =>
                          setCustomer((data) => {
                            return {
                              ...data,
                              document: ConfigMask(value.target.value),
                            };
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div style={{display: 'flex'}}>
                  <div className="area-linha-perfil-client">
                    <div className="label-client-details-chat">
                      <strong className="text-strong-label-client-edit">
                        RG/RNE:
                      </strong>
                      <input
                        className={
                          editclient ? "input-client-details-edit" : "disable-input"
                        }
                        disabled={!editclient || skuteChannelTicket}
                        maxLength={100}
                        value={customer.identification || ""}
                        onChange={(value) =>
                          setCustomer((data) => {
                            return {
                              ...data,
                              identification: value.target.value,
                            };
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="area-linha-perfil-client">
                    <div className="label-client-details-chat">
                      <strong className="text-strong-label-client-edit">
                        {i18n.t('registry')}:
                      </strong>
                      <MaskedInput
                        mask="11.111.111/1111-11"
                        maxLength="18"
                        minLength="18"
                        className={
                          editclient ? "input-client-details-edit" : "disable-input"
                        }
                        disabled={!editclient || skuteChannelTicket}
                        value={customer.companyDocument || ""}
                        onChange={(value) =>
                          setCustomer((data) => {
                            console.log(data);
                            return {
                              ...data,
                              companyDocument: ConfigMask(value.target.value),
                            };
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="container-area-client-details">
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                {i18n.t('contact')}:
                </strong>
                <input
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  maxLength={100}
                  value={customer.contact || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        contact: value.target.value,
                      };
                    })
                  }
                />
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">Email:</strong>
                <input
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  maxLength={100}
                  value={customer.email || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        email: value.target.value,
                      };
                    })
                  }
                />
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('bornDate')}:
                </strong>
                <input
                  type="date"
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  style={{ maxWidth: 250 }}
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.dateBirth ? customer.dateBirth : ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        dateBirth: value.target.value,
                      };
                    })
                  }
                />
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong>{`Whatsapp: `}</strong>
                <MaskedInput
                  mask={cellphoneDb && cellphoneDb.length === 12 ? "+11 (11) 1111-1111" : "+11 (11) 11111-1111"}
                  className="disable-input"
                  disabled={skuteChannelTicket}
                  value={customer.cellPhone || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        cellPhone: ConfigMask(value.target.value),
                      };
                    })
                  }
                />
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">Tipo: </strong>
                <select
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.CompanyCustomerTypeId || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        CompanyCustomerTypeId: value.target.value,
                      };
                    })
                  }
                >
                  <option value="">{i18n.t('select')}</option>
                  {listUsersTypes.map((data) => (
                    <option key={data.id} value={data.id}>{data.description}</option>
                  ))}
                </select>
              </div>
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">{i18n.t('genderOption')}:</strong>
                <select
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.gender || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        gender: value.target.value,
                      };
                    })
                  }
                >
                  <option value="">{i18n.t('select')}</option>
                  <option value="M">{i18n.t('genderMenOption')}</option>
                  <option value="F">{i18n.t('genderFemaleOption')}</option>
                  <option value="NI">{i18n.t('genderNotInformed')}</option>
                </select>
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('secundaryEmail')}:
                </strong>

                <input
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  maxLength={100}
                  value={customer.secondaryEmail || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        secondaryEmail: value.target.value,
                      };
                    })
                  }
                />
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('phone')} 1:
                </strong>
                <MaskedInput
                  mask={"+11 (11) 11111-1111"}
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.phone1 || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        phone1: ConfigMask(value.target.value),
                      };
                    })
                  }
                />
              </div>
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('branch')} 1:
                </strong>
                <input
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  maxLength={8}
                  value={customer.branch1 || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        branch1: value.target.value,
                      };
                    })
                  }
                />
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('phone')} 2:
                </strong>
                <MaskedInput
                  mask={"+11 (11) 11111-1111"}
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.phone2 || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        phone2: ConfigMask(value.target.value),
                      };
                    })
                  }
                />
              </div>
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('branch')} 2:
                </strong>
                <input
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  maxLength={8}
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.branch2 || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        branch2: value.target.value,
                      };
                    })
                  }
                />
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('phone')} 3:
                </strong>
                <MaskedInput
                  mask={"+11 (11) 11111-1111"}
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.phone3 || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        phone3: ConfigMask(value.target.value),
                      };
                    })
                  }
                />
              </div>
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('branch')} 3:
                </strong>
                <input
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  maxLength={8}
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.branch3 || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        branch3: value.target.value,
                      };
                    })
                  }
                />
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <p className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">{i18n.t('zipCode')}:</strong>
                <MaskedInput
                  mask="11111-111"
                  maxLength="8"
                  minLength="8"
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.zipCode || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        zipCode: ConfigMaskCEP(value.target.value),
                      };
                    })
                  }
                />
              </p>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                {i18n.t('address')} :
                </strong>
                <input
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  maxLength={100}
                  value={customer.address || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        address: value.target.value,
                      };
                    })
                  }
                />
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">Nº:</strong>
                <input
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  maxLength={20}
                  disabled={!editclient || skuteChannelTicket}
                  type="number"
                  min='0'
                  value={customer.number || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        number: value.target.value,
                      };
                    })
                  }
                />
              </div>
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('complement')}:
                </strong>
                <input
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  maxLength={40}
                  value={customer.complement || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        complement: value.target.value,
                      };
                    })
                  }
                />
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">{i18n.t('neighborhood')} :</strong>
                <input
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  maxLength={100}
                  value={customer.district || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        district: value.target.value,
                      };
                    })
                  }
                />
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">{i18n.t('city')} :</strong>
                <input
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.city || ""}
                  maxLength={100}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        city: value.target.value,
                      };
                    })
                  }
                />
              </div>
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">{i18n.t('state')} :</strong>
                <select
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  style={{ maxWidth: 250 }}
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.state || ""}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        state: value.target.value,
                      };
                    })
                  }
                >
                  <option value="">{i18n.t('select')}</option>
                  {states.map((data, index) => (
                    <option key={index} value={data.value}>
                      {data.value}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('sellEmail')}:
                </strong>
                <select
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  style={{ maxWidth: 250 }}
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.acceptPurchaseEmail}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        acceptPurchaseEmail: value.target.value,
                      };
                    })
                  }
                >
                  <option value="">{i18n.t('select')}</option>
                  <option value={true}>{i18n.t('yes')}</option>
                  <option value={false}>{i18n.t('no')}</option>
                </select>
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('rememberEmail')} :
                </strong>
                <select
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  style={{ maxWidth: 250 }}
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.acceptPurchaseReminder}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        acceptPurchaseReminder: value.target.value,
                      };
                    })
                  }
                >
                  <option value="">{i18n.t('select')}</option>
                  <option value={true}>{i18n.t('yes')}</option>
                  <option value={false}>{i18n.t('no')}</option>
                </select>
              </div>
            </div>
            <div className="area-linha-perfil-client">
              <div className="label-client-details-chat">
                <strong className="text-strong-label-client-edit">
                  {i18n.t('activeCall')} :
                </strong>
                <select
                  className={
                    editclient ? "input-client-details-edit" : "disable-input"
                  }
                  style={{ maxWidth: 250 }}
                  disabled={!editclient || skuteChannelTicket}
                  value={customer.acceptActiveCall}
                  onChange={(value) =>
                    setCustomer((data) => {
                      return {
                        ...data,
                        acceptActiveCall: value.target.value,
                      };
                    })
                  }
                >
                  <option value="">{i18n.t('select')}</option>
                  <option value={true}>{i18n.t('yes')}</option>
                  <option value={false}>{i18n.t('no')}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="area-btn-editar-data-client">
            <>
              {btnGoBack ? (
                <button
                  type="button"
                  className="btn btn-outline-danger mt-2 mr-2"
                  style={{ height: 38 }}
                  onClick={() => history.goBack()}
                >
                  {" "}
                  <i className="dripicons-gear"></i> {i18n.t('getBack')}
                </button>
              ) : (
                <></>
              )}
              <button
                type="submit"
                className="btn btn-outline-success mt-2"
                style={{ height: 38 }}
                disabled={!editclient || skuteChannelTicket}
              >
                {" "}
                <i className="dripicons-gear"></i> {i18n.t('save')}
              </button>
            </>
        </div>
      </div>
    </form>
  );
}
